import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import TipoPerfilUsuarioEnum from '../../../enums/TipoPerfilUsuarioEnum';

import { ContentText } from './styles';

const BodySelectedTipoPerfil = () => {
  return (
    <ContentText>
      Qual tipo de permissão de contratante deseja parametrizar?
    </ContentText>
  );
};

const FooterSelectedTipoPerfil = ({ handleSelectedTipoPerfil }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button
        tipo="secondary"
        onClick={() =>
          handleSelectedTipoPerfil(
            TipoPerfilUsuarioEnum.returnNameForName.ContratanteConsulta
          )
        }
        justifyCenter
      >
        consulta
      </Button>
      <Button
        onClick={() =>
          handleSelectedTipoPerfil(
            TipoPerfilUsuarioEnum.returnNameForName.ContratanteAlteracao
          )
        }
        justifyCenter
      >
        alteração
      </Button>
    </WrapperFlex>
  );
};

export default {
  BodySelectedTipoPerfil,
  FooterSelectedTipoPerfil,
};
